/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Parq_WordsInputs */

const en_us2_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`health parq questionnaire heart blood pressure doctor`)
};

const pt_br2_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saude parq questionario coracao pressao medico`)
};

const es_419_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`salud parq cuestionario corazon presion medico`)
};

const pt_pt2_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saude parq questionario coracao tensao pressao medico`)
};

const fr_fr2_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sante parq questionnaire coeur tension medecin`)
};

const de_de2_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gesundheit parq fragebogen herz blutdruck arzt`)
};

const it_it2_search_field_parq_words = /** @type {(inputs: Search_Field_Parq_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`salute parq questionario cuore pressione medico`)
};

/**
* | output |
* | --- |
* | "health parq questionnaire heart blood pressure doctor" |
*
* @param {Search_Field_Parq_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_parq_words = /** @type {((inputs?: Search_Field_Parq_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Parq_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_parq_words(inputs)
	if (locale === "es-419") return es_419_search_field_parq_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_parq_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_parq_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_parq_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_parq_words(inputs)
	return en_us2_search_field_parq_words(inputs)
});
export { search_field_parq_words as "search.field_parq_words" }